<template>
  <v-expansion-panel-content
    :key="id"
    expand-icon=""
    :class="{
      'mb-4 content-bg--2': !mobile,
      'content-bg--5 border-light': mobile
    }"
  >
    <template #header v-if="mobile">
      <div class="font-weight-medium my-2">
        <div
          class="font-weight-bold layout align-center justify-space-between"
          :class="{
            'display-2': mobile,
            'display-3': !mobile
          }"
        >
          <div class="flex">
            {{ item.ssid_hotspot }}
          </div>
          <icon-angle size="10" class="icon-angle"></icon-angle>
        </div>
        <div
          class="subtitle-2 pt-2 pr-5 text--secondary font-weight-regular text-capitalize"
        >
          {{ item.title }}:
          <span class="text-capitalize">{{ item.address }}</span>
        </div>
        <div v-if="item.sms" class="pt-2 line-height-1 subtitle-2">
          {{ item.title }}: {{ item.sms.cntMonth }} СМС потрачено с {{ start }}
        </div>
        <div class="pt-2 line-height-1 error--text subtitle-2">
          Всего: {{ item.smsCount }} СМС
          <span class="text--primary">до {{ end }}</span>
        </div>
      </div>
    </template>
    <v-flex
      class="layout justify-end py-2 pr-3 text--secondary subtitle-1 font-weight-medium"
    >
      ID: {{ item.cl_service_id }}
    </v-flex>
    <v-layout
      :class="{
        'pt-2 pb-5 pr-5 expansion-panel-border': !mobile,
        'px-4 py-2': mobile
      }"
      class="v-form"
      wrap
      align-start
    >
      <v-flex
        v-if="$vuetify.breakpoint.smAndUp"
        xl3
        lg3
        sm4
        xs12
        text-xs-center
      >
        <theme-preview :themeId="item.theme_id"></theme-preview>
      </v-flex>
      <v-flex xl9 lg9 sm8 xs12 class="layout wrap">
        <v-flex v-if="!mobile" xs12 class="display-3 font-weight-bold">
          Хот-спот:
          <span>
            {{ item.title }}
            <v-btn
              @click="
                $emit('openDialog', {
                  component: 'hotspotEditName',
                  id: item.id
                })
              "
              icon
              small
              class="ma-0"
            >
              <hint-widget hintName="changeTitleHotspot" type="tooltip">
                <template slot="activatorHint">
                  <icon-pencil></icon-pencil>
                </template>
              </hint-widget>
            </v-btn>
          </span>
        </v-flex>
        <v-flex
          v-if="$vuetify.breakpoint.smAndUp"
          class="subtitle-2 pb-4 pt-2 text--secondary font-weight-medium"
          xs12
        >
          адрес: <span class="text-capitalize">{{ item.address }}</span>
        </v-flex>
        <v-flex v-if="!item.tarif_id" class="error--text">
          <icon-exclamation size="18" class="mr-2"></icon-exclamation>
          <span>Хотспоту не назначен тариф. Обратитесь в Тех. поддержку.</span>
        </v-flex>
        <v-flex v-if="item.tarif_id" xl4 md6 sm6 pb-4 order-sm1 order-xs2>
          <v-layout align-center>
            <v-flex xs10>
              <label>Тема</label>
              <v-select
                @change="setTheme"
                :value="item.theme_id"
                :items="$store.getters.themeList"
                item-value="id"
                item-text="name"
                class="pb-3"
                append-icon=""
                hide-details
                dense
                solo
                clear-icon="icon icon-close-xs"
                clearable
              >
                <template #append>
                  <icon-angle class="ma-0 link"></icon-angle>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="ellipsis">{{ item.name }}</div>
                </template>
              </v-select>
            </v-flex>
            <v-btn
              v-if="item.theme_id"
              :to="{ name: 'themeSettings', params: { id: item.theme_id } }"
              icon
              class="ma-0 mt-sm-2 mt-1"
            >
              <icon-pencil></icon-pencil>
            </v-btn>
            <hint-widget v-else hintName="hotspotTheme" type="tooltip">
              <template slot="activatorHint">
                <v-btn class="ma-0 mt-sm-2 mt-1" icon>
                  <icon-help></icon-help>
                </v-btn>
              </template>
            </hint-widget>
          </v-layout>
          <v-layout align-center>
            <v-flex xs10>
              <label>Опрос</label>
              <v-select
                @change="setPoll"
                :value="item.poll_id"
                :items="$store.getters.pollList()"
                item-value="id"
                item-text="name"
                class="pb-3"
                append-icon=""
                hide-details
                dense
                solo
                clear-icon="icon icon-close-xs"
                clearable
              >
                <template #append>
                  <icon-angle class="ma-0 link"></icon-angle>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="ellipsis">{{ item.name }}</div>
                </template>
              </v-select>
            </v-flex>
            <v-btn
              v-if="item.poll_id"
              :to="{ name: 'pollSettings', params: { id: item.poll_id } }"
              icon
              class="ma-0 mt-sm-2 mt-1"
            >
              <icon-pencil></icon-pencil>
            </v-btn>
            <hint-widget v-else hintName="hotspotPolls" type="tooltip">
              <template slot="activatorHint">
                <v-btn class="ma-0 mt-sm-2 mt-1" icon>
                  <icon-help></icon-help>
                </v-btn>
              </template>
            </hint-widget>
          </v-layout>
          <v-layout align-center>
            <v-flex xs10 pb-3>
              <label>Реклама</label>
              <v-select
                @change="setAdv"
                :value="item.advertising_id"
                :items="$store.getters.advList()"
                item-value="id"
                item-text="name"
                append-icon=""
                hide-details
                dense
                solo
                clear-icon="icon icon-close-xs"
                clearable
              >
                <template #append>
                  <icon-angle class="ma-0 link"></icon-angle>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="ellipsis">{{ item.name }}</div>
                </template>
              </v-select>
            </v-flex>
            <v-btn
              v-if="item.advertising_id"
              :to="{
                name: 'advSettings',
                params: { id: item.advertising_id }
              }"
              icon
              class="ma-0 mt-sm-2 mt-1"
            >
              <icon-pencil></icon-pencil>
            </v-btn>
            <hint-widget v-else hintName="hotspotAdv" type="tooltip">
              <template slot="activatorHint">
                <v-btn class="ma-0 mt-sm-2 mt-1" icon>
                  <icon-help></icon-help>
                </v-btn>
              </template>
            </hint-widget>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="item.tarif_id"
          class="xl4 md6 sm6 xs12 font-weight-medium pb-4 order-sm2 order-xs1"
          style="position: relative"
        >
          <v-flex class="pl-sm-3 pb-sm-3 subtitle-1">
            Открытая сеть:
            <div
              class="display-1 font-weight-bold text-no-wrap layout align-center"
            >
              <span v-if="item.ssid_hotspot">{{ item.ssid_hotspot }}</span>
              <span v-else>нет</span>
              <v-tooltip v-if="timer && timer.isActive" right>
                <template slot="activator">
                  <v-btn class="ma-0" icon small>
                    <icon-clock></icon-clock>
                  </v-btn>
                </template>
                <span>
                  Название сети можно поменять через:
                  <span>{{ formatted }}</span>
                </span>
              </v-tooltip>
              <v-btn
                v-else
                @click="
                  $emit('openDialog', {
                    component: 'hotspotEditWifi',
                    param: 'ssid_hotspot',
                    id: item.id
                  })
                "
                icon
                small
                class="ma-0"
              >
                <icon-pencil></icon-pencil>
              </v-btn>
            </div>
          </v-flex>
          <v-flex class="subtitle-1 pl-sm-3 pb-sm-3">
            Закрытая сеть
            <span v-if="item.rate_work">{{ item.rate_work }} мбит/с</span>
            :
            <div class="text-no-wrap layout align-center">
              <span v-if="item.ssid_work" class="display-1 font-weight-bold">
                {{ item.ssid_work }}
              </span>
              <span v-else>нет</span>
              <v-tooltip v-if="timer && timer.isActive" right>
                <template slot="activator">
                  <v-btn class="ma-0" icon small>
                    <icon-clock></icon-clock>
                  </v-btn>
                </template>
                <span>
                  Название сети можно поменять через:
                  <span>{{ formatted }}</span>
                </span>
              </v-tooltip>
              <v-btn
                v-else
                @click="
                  $emit('openDialog', {
                    component: 'hotspotEditWifi',
                    param: 'ssid_work',
                    id: item.id
                  })
                "
                icon
                small
                class="ma-0"
              >
                <icon-pencil></icon-pencil>
              </v-btn>
            </div>
            <div class="text-no-wrap layout align-center">
              <span class="pr-2 font-weight-bold">пароль:</span>
              <span v-if="item.wifipassword">
                {{ item.wifipassword }}
              </span>
              <span v-else>нет</span>
              <v-tooltip v-if="timer && timer.isActive" right>
                <template slot="activator">
                  <v-btn class="ma-0" icon small>
                    <icon-clock></icon-clock>
                  </v-btn>
                </template>
                <span>
                  Пароль можно поменять через:
                  <span>{{ formatted }}</span>
                </span>
              </v-tooltip>
              <span v-else>
                <v-btn
                  @click="
                    $emit('openDialog', {
                      component: 'hotspotEditWifi',
                      param: 'wifipassword',
                      id: item.id
                    })
                  "
                  icon
                  small
                  class="ma-0"
                >
                  <icon-pencil></icon-pencil>
                </v-btn>
              </span>
            </div>
          </v-flex>
          <v-layout pl-sm-3>
            <div
              v-if="item.sms"
              :class="{
                'error--text': item.sms.balance < 0
              }"
            >
              Баланс: {{ item.sms.balance }} СМС
              <div class="subtitle-2 text--secondary" :id="'popover' + item.id">
                до {{ end }}
              </div>
              <div v-if="item.sms" class="subtitle-2 text--secondary mt-1">
                {{ item.sms.cntMonth }} СМС потрачено с {{ start }}
              </div>
            </div>
          </v-layout>
          <div v-if="item.sms.balance < 0" class="pl-3">
            <!-- tailed-menu  для хвостика v-menu-->
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :close-on-click="false"
              :max-width="360"
              :nudge-width="260"
              :attach="'#popover' + item.id"
            >
              <template slot="activator">
                <v-spacer></v-spacer>
              </template>
              <div
                class="font-weight-medium subtitle-1 pl-3 pb-3 pt-2 pr-2 content-bg--6"
              >
                <v-layout
                  class="align-center justify-space-between error--text"
                >
                  <span>
                    <icon-exclamation size="18" class="mr-2"></icon-exclamation>
                    <span>Лимит СМС превышен!</span>
                  </span>
                  <v-btn
                    @click="menu = false"
                    class="btn-close align-self-end ma-0 mb-2"
                    icon
                  >
                    <icon-close
                      size="20"
                      :color="
                        $store.getters.popupType === 'error'
                          ? 'white'
                          : this.$vuetify.theme.textPrimary
                      "
                    ></icon-close>
                  </v-btn>
                </v-layout>
                <div class="ml-3 pl-2 text--primary">
                  Все последующие СМС
                  <div class="pt-1">по {{ item.sms.priceMoreCount }} ₽/шт.</div>
                </div>
              </div>
            </v-menu>
          </div>
          <div class="pl-3">
            <router-link
              v-if="$vuetify.breakpoint.smAndUp"
              :to="{
                name: 'detailing',
                params: { hotspotName: item.hotspot_name }
              }"
              class="subtitle-2 font-weight-medium link layout align-center text--primary pt-3"
            >
              <icon-arrow-right class="mr-2"></icon-arrow-right>
              <span class="subtitle-2 font-weight-medium">
                К детализации
              </span>
            </router-link>
          </div>
        </v-flex>
        <v-flex v-if="item.tarif_id" xl4 md6 sm6 xs12 order-xs3>
          <statistics-auth-widget
            :hotspot-name="item.hotspot_name"
            :hotspot_id="item.id"
          ></statistics-auth-widget>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-expansion-panel-content>
</template>

<script>
import IconPencil from "../icon/IconPencil.vue";
import IconAngle from "../icon/IconAngle.vue";
import IconClock from "../icon/IconClock.vue";
import IconExclamation from "../icon/IconExclamation.vue";
import IconClose from "../icon/IconClose.vue";
import IconHelp from "../icon/IconHelp.vue";
import IconArrowRight from "../icon/IconArrowRight.vue";
import ThemePreview from "../theme/ThemePreview.vue";
import StatisticsAuthWidget from "../statistics/StatisticAuthWidget.vue";
import HintWidget from "../common/HintWidget.vue";
import moment from "moment";

export default {
  name: "HotspotItem",

  components: {
    StatisticsAuthWidget,
    HintWidget,
    ThemePreview,
    IconAngle,
    IconPencil,
    IconExclamation,
    IconClose,
    IconArrowRight,
    IconClock,
    IconHelp
  },

  props: {
    // id хотспота
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    // для отображения всплывашки по лимиту смс
    menu: true
  }),

  computed: {
    // объект хотспота
    item() {
      let item = this.$store.getters.getHotspot(this.id);
      if (item.hotspot_themes.length) {
        item.theme_id = item.hotspot_themes[0].theme_id;
      } else {
        item.theme_id = null;
      }
      return item;
    },
    theme() {
      return this.$store.getters.getTheme(this.item.theme_id);
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    // объект пользователя
    user() {
      return this.$store.getters.user;
    },
    // старт отсчета периода
    start() {
      return moment()
        .date(1)
        .format("D MMMM");
    },
    // конец отсчета периода
    end() {
      return moment()
        .add(1, "months")
        .date(0)
        .format("D MMMM");
    },
    //название хотспота
    hotspotName() {
      return this.$store.getters.getHotspot(this.item.id)["hotspot_name"];
    },
    // значения таймера из store
    timer() {
      return this.$store.getters.timerHotspot[this.item.id];
    },
    // отформатированный вывод значения таймера
    formatted() {
      let minutes = null,
        seconds = null;
      if (this.timer) {
        minutes = Math.floor(this.timer.timerMikrotik / 60);
        seconds = this.timer.timerMikrotik % 60;

        if (minutes < 10) {
          minutes = `0${String(minutes)}`;
        }
        if (seconds < 10) {
          seconds = `0${String(seconds)}`;
        }
      }
      return minutes + ":" + seconds;
    }
  },

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad");

    // если timer в стор не пустой, то отсчет начинается с этого значения
    if (this.timer)
      this.$store.dispatch("runTimer", {
        id: this.item.id,
        timerMikrotik: this.timer.timerMikrotik
      });
  },

  methods: {
    /**
     * Прикрепляет тему к хотспоту
     */
    setTheme(val) {
      // удаляем если есть уже тема
      this.$store
        .dispatch("deleteHotspotTheme", { hotspot_id: this.item.id })
        .then(() => {
          if (val) {
            this.$store
              .dispatch("createHotspotTheme", {
                hotspot_id: this.item.id,
                theme_id: val
              })
              .then(() => {
                // открываем сообщение
                this.$store.dispatch("popupInfoOpen", {
                  text: "Тема успешно прикреплена к хотспоту"
                });
              });
          }
        });
    },

    /**
     * Прикрепляет рекламу к хотспоту
     */
    setAdv(advertising_id) {
      let params;
      if (!advertising_id)
        params = { advertising_id: this.item.advertising_id, deleted: true };
      else params = { advertising_id: advertising_id };
      params = {
        ...params,
        ...{
          id: this.item.id,
          address: this.item.address,
          title: this.item.title
        }
      };
      this.$store.dispatch("pinHotspotAdv", params).then(() => {
        // открываем сообщение
        this.$store.dispatch("popupInfoOpen", {
          text: !advertising_id
            ? "Реклама успешно откреплена"
            : "Реклама успешно прикреплена"
        });
      });
    },
    /**
     * Прикрепление опроса к хотспоту
     */
    setPoll(poll_id) {
      let params;
      if (!poll_id) params = { poll_id: this.item.poll_id, deleted: true };
      else params = { poll_id: poll_id };
      params = {
        ...params,
        ...{
          id: this.item.id,
          address: this.item.address,
          title: this.item.title
        }
      };
      this.$store
        .dispatch("pinHotspot", params)
        .then(() => {
          this.item.poll_id = poll_id;
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: !poll_id
              ? "Опрос успешно откреплен"
              : "Опрос успешно прикреплен"
          });
        })
        .catch();
    }
  }
};
</script>
